import React from 'react';
import ProductFulfillmentListContainer from 'containers/ProductFulfillmentListContainer';
import ProductFulfillmentListCacheContainer, {
  ProductFulfillmentListCacheQueryResults
} from 'containers/ProductFulfillmentListCacheContainer';
import ProductFulfillmentList from 'views/components/ProductFulfillments/ProductFulfillmentList';
import { TableHeading } from 'models/interfaces/Table';
import Table from 'views/components/Table/TableComponent';
import { printDate } from 'util/dateUtils';
import { getFulfillmentStatus } from 'util/p3Validation';
import { Link } from 'react-router-dom';
import { CONSTANTS } from '@tpco/tpco-saturn-types';

class ProductFulfillmentListPage extends React.Component {
  configureProductFulfillmentData = (productFulfillments: any[]) => {
    productFulfillments.map(productFulfillment => {
      productFulfillment.campaign_name = (
   
          <Link
            to={`/advertisers/${productFulfillment.tgrams_id}/campaigns/${
              productFulfillment.campaign_id
            }/edit`}
          >
            {productFulfillment.campaign_name}
          </Link>
        ) ;
      productFulfillment.advertiser_name =
         (
          <Link to={`/advertisers/${productFulfillment.tgrams_id}`}>
            {productFulfillment.account_name}
          </Link>
        );
      productFulfillment.start_date = productFulfillment.start_date
        ? printDate(productFulfillment.start_date)
        : '';
      productFulfillment.end_date = productFulfillment.end_date
        ? printDate(productFulfillment.end_date)
        : '';

      productFulfillment.status = CONSTANTS.CAMPAIGN_STATUS_MAP[productFulfillment.status_id];

      productFulfillment.product = CONSTANTS.PRODUCT_TYPE_MAP[productFulfillment.product_id]
        
    });
  };
  render() {
    const productFulfillmentHeading: TableHeading[] = [
      {
        key: 'advertiser_name',
        value: 'Company Name'
      },
      {
        key: 'tgrams_id',
        value: 'Company ID',
        style: 'align-right'
      },
      {
        key: 'campaign_name',
        value: 'Campaign'
      },
      {
        key: 'status',
        value: 'Status'
      },
      {
        key: 'start_date',
        value: 'Start Date',
        style: 'align-right'
      },
      {
        key: 'end_date',
        value: 'End Date',
        style: 'align-right'
      },
      {
        key: 'opportunity_id',
        value: 'Opportunity ID'
      },
      {
        key: 'item_id',
        value: 'Item ID'
      },
      {
        key: 'product',
        value: 'Product'
      },
      {
        key: 'quantity',
        value: 'Quantity',
        style: 'align-right'
      }
    ];

    return (
      <section>
        <h1 className="page-title">Pending Campaigns</h1>
        <section className="card">
          <ProductFulfillmentListCacheContainer>
            {({
              productFulfillmentListCache,
              updateCache,
              updateProductFulfillmentPage
            }: ProductFulfillmentListCacheQueryResults) => {
              return (
                <ProductFulfillmentListContainer
                  size={productFulfillmentListCache.size}
                  from={productFulfillmentListCache.from}
                >
                  {({ productFulfillments, resultsCount }) => {
                    this.configureProductFulfillmentData(productFulfillments);
                    console.log(productFulfillments);
                    return (
                      <Table
                        headings={productFulfillmentHeading}
                        data={productFulfillments}
                        updatePage={updateProductFulfillmentPage}
                        size={productFulfillmentListCache.size}
                        from={productFulfillmentListCache.from}
                        resultsCount={resultsCount}
                      />
                    );
                  }}
                </ProductFulfillmentListContainer>
              );
            }}
          </ProductFulfillmentListCacheContainer>
        </section>
      </section>
    );
  }
}

export default ProductFulfillmentListPage;
